import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuditTrailService } from 'src/app/services/audit-trail/audit-trail.service';
import { DataService } from 'src/app/services/data/data.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.sass'],
})
export class HistoryComponent implements OnInit {
  dataServiceSub: Subscription;
  currLoc;
  auditTrails;
  annotName;
  csvData;

  unsubber: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private dataService: DataService,
    private _t: TranslateService,
    private auditTrailService: AuditTrailService,
    private locationStore: LocationStoreService
  ) {
    this.dataServiceSub = this.locationStore.currLocation$.subscribe((res) => {
      if (res.id) this.currLoc = res;
    });
  }

  ngOnInit(): void {
    this._t.onLangChange
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        if (this.currLoc?.id) {
          this.generateCsvData();
        }
      });

    this.dataServiceSub = this.locationStore.currLocation$.subscribe((res) => {
      if (res.id) {
        this.currLoc = res;
        if (this.currLoc.auditTrails) {
          this.auditTrails = this.currLoc.auditTrails;
          this.generateCsvData();
        } else {
          this.auditTrailService.findAll(res.id).subscribe(
            (res) => {
              this.auditTrails = this.currLoc.auditTrails = res.data;
              this.generateCsvData();
            },
            ({ error }) => {
              this.auditTrails = [];
            }
          );
        }
      }
    });
  }

  generateCsvData() {
    const data = [];
    for (const auditTrail of this.auditTrails) {
      const user = auditTrail.user;

      const role = user?.roles[0] || '';

      const dateStrArr = new Date(auditTrail.created_at).toString().split(' ');
      const translateParams = {
        day: this._t.instant(dateStrArr[0]),
        dateM: this._t.instant(dateStrArr[1]),
        dateD: this._t.instant(dateStrArr[2]),
        dateY: this._t.instant(dateStrArr[3]),
        time: this._t.instant(dateStrArr[4]),
        tz: this._t.instant(dateStrArr[5]),
        tzdescription: this._t.instant(dateStrArr[6] + ' ' + dateStrArr[7]),
      };

      data.push({
        [this._t.instant('Name')]: user?.fullname,
        [this._t.instant('Role')]: this._t.instant(
          role === 'SuperAdmin' ? 'Maintainer' : role
        ),
        [this._t.instant('Email')]: user?.email,
        [this._t.instant('Action')]: this._t.instant(
          this.checkLength(auditTrail.title)
        ),
        [this._t.instant('Date')]: this._t.instant(
          '{{day}} {{dateM}} {{dateD}} {{dateY}} {{time}} {{tz}} {{tzdescription}}',
          translateParams
        ),
      });
    }
    this.csvData = data;
  }

  checkLength(sentence) {
    if (sentence === 'Update Project Details') return sentence;
    this.annotName = sentence.split(' ').splice(2).join(' ');
    return sentence.split(' ').slice(0, 2).join(' ');
  }
}
